module.exports = "h1 {\r\n    color: #9E2627\r\n     /* rgba(92, 8, 8, 0.945); */\r\n  }\r\n  h1 {\r\n    margin: 50px 30px 50px 50px;\r\n  }\r\n  p {\r\n    margin-top: 30px;\r\n    /*margin-bottom: 100px; */\r\n    margin-right: 150px;\r\n    margin-left: 50px;\r\n  }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/training-programs/training-programs.component.css
// module id = ./src/app/training-programs/training-programs.component.css
// module chunks = main